import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const deleteTicket = createAsyncThunk('ticket/delete-ticket', async ({ ticketId }, { getState, rejectWithValue }) => {
  const { loginToken } = getState();
  const authToken = loginToken?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/ticket/delete-ticket/${ticketId}`,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    const result = await response.json();
    return result;    
  } catch (error) {
    return rejectWithValue(error);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const DeleteTicket = createSlice({
  name: 'DeleteTicket',
  initialState,
  reducers: {},
  extraReducers: {
    [deleteTicket.pending]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [deleteTicket.fulfilled]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
      isError: false,
      response: action.payload,
    }),
    [deleteTicket.rejected]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      isError: true,
      error: action.payload,
    }),
  },
});

export default DeleteTicket; 